type Context = 'local-registers';

type Section = 'slug';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  slug: 'local-registers-slug',
};
